<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-one-australia-the-natural-world-and-our-interactions-with-it">
<h1 style="margin-top:250px;font-family:Arial;">Part One<br/> Australia: The Natural World <br/>(And Our Interactions with it)</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?4ef95fba